import React, {useState, useEffect, useContext} from 'react'
import {Formik, Field, Form} from 'formik'
import {FormActions} from '@/components/form'
import {getComputedBalance, flushBalance} from '../../../core/_requests'
import {CustomerContext} from '../../CustomerContext'
import {useListView} from '@/components/table/core/ListViewProvider'
import {Alert} from '@/components/Alert'

const ReconcileBalanceForm  = () => {
  const { customer, refresh: refreshUser  } = useContext(CustomerContext)
  const {setItemForUpdate, setAction} = useListView()
  const [balance, setBalance] = useState<number | undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const close = () => {
    setItemForUpdate(undefined)
    setAction(undefined)
  }

  useEffect(() => {
    const load = async () => {
      if (!customer) {
        return
      }
      try {
        setIsLoading(true)
        const res = await getComputedBalance(customer._id)
        if (res) {
          setBalance(res.balance)
        }
      } catch (e) {
        console.log('Could not get balance', e)
      } finally {
        setIsLoading(false)
      }
    }

    load()
  }, [customer])

  if (!customer) {
    return <></>
  }

  return (
    <Formik
      initialValues={{}}
      onSubmit={async () => {
        try {

          await flushBalance(customer._id)
          //refreshUser()
        } catch (e: unknown) {
          console.log('Coul not flush balance', e)
        }
      }}
    >
      {() => (
        <Form id="brand" className='form'>
          {!isLoading ? (
            <>
              {customer.balance === balance ? (
                <Alert type="success" icon="check" title="Balance match" />
              ) : (
                <Alert
                  type="danger"
                  icon="information-5"
                  title="Balance missmatch"
                  message={`User balance: ${customer.balance}, computed balance: ${balance}`}
                />
              )}
            </>
          ) : (
            <>Loading ...</>
          )}
          <Field
            padding="pt-3"
            component={FormActions}
            disabled={customer.balance === balance}
            confirmBtnLabel="Reconcile balance"
            position="end"
            close={close}
          />
        </Form>
      )}
    </Formik>
  )
}

export default ReconcileBalanceForm
